import gql from "graphql-tag";

import { ContractTemplate, Fragment } from "../types";

export const CONTRACT_TEMPLATE_MINIMAL_FRAGMENT = gql`
  fragment ContractTemplateMinimalFragment on ContractTemplate {
    id
    slug
    title
  }
`;

export type ContractTemplateMinimalFragment = Fragment<
  ContractTemplate,
  Pick<ContractTemplate, "id" | "slug" | "title">
>;

export const CONTRACT_TEMPLATE_SUMMARY_FRAGMENT = gql`
  fragment ContractTemplateSummaryFragment on ContractTemplate {
    id
    slug
    title
    body
    signatories
  }
`;

export type ContractTemplateSummaryFragment = Fragment<
  ContractTemplate,
  Pick<ContractTemplate, "id" | "slug" | "title" | "body" | "signatories">
>;
